import CrashDetectionLockedModal from './CrashDetectionLockedModal'

export default CrashDetectionLockedModal
